export default __webpack_public_path__ + "static/media/NILWAIVER.c28772b1.jpg";